import { transactionsSelectors } from 'app-components/flux/transactions';
import { type Map as ImMap, OrderedMap } from 'immutable';
import { createSelector } from 'reselect';

export const getPayeesForTransactions = createSelector(
  transactionsSelectors.getTransactionsById,
  (transactions: ImMap<string, any /* Transaction */>): OrderedMap<string, string> =>
    OrderedMap<string, string>().withMutations((payees) =>
      transactions.forEach((transaction) => {
        const key = transaction.payee?.toLowerCase();
        if (
          transaction.type === 'CASH_FLOW' &&
          !transaction.isDeleted &&
          transaction.payee?.length &&
          key &&
          !payees.has(key)
        ) {
          payees.set(key, transaction.payee);
        }
      }),
    ),
);

export const getPayeesNamesSorted = createSelector(getPayeesForTransactions, (payeesMap) =>
  payeesMap.toList().sort((a, b) => a.localeCompare(b)),
);
